import Checkbox from "@ui-components/Checkbox";
import ConfiguratorSurveyTitle from "@components/ConfiguratorSurveyTitle";
import React from "react";
import {SurveySelectionEditorProps} from "./types";
import {FormattedMessage} from "react-intl";

export const SurveysSelectionEditor = ({
  services,
  servicesSurveys,
  checkedSurveys,
  setCheckedSurveys,
  creators,
}: SurveySelectionEditorProps) => {

  if (!servicesSurveys?.length)
    return (
      <div className="w-full h-40 flex flex-col items-center justify-center gap-1 p-4 text-center">
        <p className="text-base font-medium">
          <FormattedMessage id="no_surveys" defaultMessage="Nessuna configurazione" />
        </p>
        <p>
          <FormattedMessage id="no_surveys_helper" defaultMessage="Non è disponibile nessuna configurazione per la tipologia di configuratori selezionata" />
        </p>
      </div>
    );

  return (
    <div className="flex flex-col gap-4">
      {services.map((service) => {

        const surveys = servicesSurveys
          ?.filter((s) => s.service_id === service.id );

        if (!surveys?.length)
          return;

        return (
          <div key={service.id}>
            <h3 className="uppercase font-semibold text-base mb-3">
              {service.name}
            </h3>
            <div className="flex flex-col gap-2">
              {surveys.map((survey) => (
                <div
                  key={survey.id}
                  className="flex flex-row gap-3 items-center"
                >
                  <Checkbox
                    readOnly={false}
                    id={survey.id}
                    name={survey.id}
                    checked={checkedSurveys.has(survey.id)}
                    onChange={() => {
                      setCheckedSurveys((prev) => {
                        const local = new Set(prev);
                        if (local.has(survey.id)) local.delete(survey.id);
                        else local.add(survey.id);
                        return local;
                      })
                    }}
                  />
                  <ConfiguratorSurveyTitle
                    service={survey.services}
                    survey={survey}
                    creators={creators}
                  />
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}